export default "__VITE_ASSET__CQxgLFrS__"